import {
  ShieldCheck,
  ClipboardCheck,
  Target,
  Route,
  TrendingUp,
  GraduationCap,
  FileText,
} from "lucide-react";

export const services = [
  {
    id: "quality-assurance",
    number: "01",
    icon: ShieldCheck,
    title: "Quality Assurance",
    summary:
      "Independent assurance that gives leaders and boards confidence in the quality, safety and impact of frontline practice — aligned to the criteria inspectors use.",
    deliverables: [
      "QA framework design & review",
      "CARaG-aligned case audit & moderation",
      "Practice observation & feedback",
      "Board & partnership reporting",
    ],
  },
  {
    id: "independent-audit",
    number: "02",
    icon: ClipboardCheck,
    title: "Independent Audit",
    summary:
      "Rigorous, independent audit aligned to the HMI Probation Case Assessment Rules and Guidance (CARaG) — identifying strengths, surfacing risk and revealing the patterns behind performance across Domain Two casework and work with victims.",
    deliverables: [
      "CARaG-aligned case file audits",
      "Assessing, planning, delivery & management oversight",
      "Victim work audit (Victims' Standard)",
      "Joint audits with children's social care (Ofsted-aligned)",
      "Moderation, calibration & action tracking",
    ],
  },
  {
    id: "inspection-readiness",
    number: "03",
    icon: Target,
    title: "Inspection Readiness",
    summary:
      "Confident, structured preparation for HMI Probation inspection — from honest self-assessment against the Youth Justice Rules and Guidance and CARaG criteria to a coherent evidence trail.",
    deliverables: [
      "Mock inspection activity",
      "CARaG-based self-assessment support",
      "Victims' Standard preparation",
      "Evidence trail preparation",
      "Staff briefings & coaching",
    ],
  },
  {
    id: "post-inspection-support",
    number: "04",
    icon: Route,
    title: "Post-Inspection Support",
    summary:
      "Turning inspection findings into sustained improvement — structured support to develop, implement and evidence robust post-inspection improvement plans.",
    deliverables: [
      "Post-inspection improvement planning",
      "Action plan implementation support",
      "Progress reviews & impact evidence",
      "Governance & board assurance reporting",
    ],
  },
  {
    id: "practice-improvement",
    number: "05",
    icon: TrendingUp,
    title: "Practice Improvement",
    summary:
      "Hands-on support to turn findings into lasting change — practical plans, coaching and evidence-informed models.",
    deliverables: [
      "Improvement planning",
      "Practice model development",
      "Coaching & mentoring",
      "Embedding evidence-informed practice",
    ],
  },
  {
    id: "training",
    number: "06",
    icon: GraduationCap,
    title: "Training & Development",
    summary:
      "Bespoke learning for practitioners, managers and board members, designed around your service's real priorities.",
    deliverables: [
      "Bespoke practitioner training",
      "Manager & leadership development",
      "Board member briefings",
      "Workshops & action learning",
    ],
  },
  {
    id: "policy-writing",
    number: "07",
    icon: FileText,
    title: "Policy Writing",
    summary:
      "Clear, current and compliant policies — written or refreshed to reflect legislation, inspection expectations and your local practice model.",
    deliverables: [
      "Policy review & gap analysis",
      "Policy drafting & refresh",
      "Procedure & guidance documents",
      "Consultation & implementation support",
    ],
  },
];
